export function plannedTarget(ctx) {
    return ctx.plan?.kind === 'SPELL' ? ctx.plan.targetInstanceId : undefined;
}
export function isLiveAlly(state, playerId, instanceId) {
    if (instanceId === undefined)
        return false;
    const instance = state.instances[instanceId];
    return instance !== undefined && (instance.controllerId ?? instance.ownerId) === playerId && instance.zone === 'board'
        && instance.cellId !== undefined && state.board.cells[instance.cellId]?.occupantId === instanceId;
}
export function spellPlanTarget(plan) {
    return plan.targetInstanceId;
}
//# sourceMappingURL=helpers.js.map